import { useState } from 'react'

import { useCopyToClipboard, useNotification } from '../../../../hooks'
import { stopPropagation } from '../../../../utils/events'
import { ProfileUsersWidgetItem } from '../../../Widget'

import { COPIED_STATE_RESET_TIMEOUT } from './EmailProfileWidgetParticipantsItem.constants'
import { EmailProfileWidgetParticipantsItemIcons } from './EmailProfileWidgetParticipantsItemIcons'

function EmailProfileWidgetParticipantsItem({ value, ...restProps }) {
  const [, copy] = useCopyToClipboard({ onSuccess: handleSuccessCopy })

  const { handleAddSuccessNotification } = useNotification()

  const [copied, setCopied] = useState(false)

  function handleSuccessCopy() {
    setCopied(true)

    handleAddSuccessNotification(
      'Notification.EmailProfileParticipantsWidgetItemEmailCopiedKey'
    )

    setTimeout(() => {
      setCopied(false)
    }, COPIED_STATE_RESET_TIMEOUT)
  }

  function handleClickCopy(event) {
    stopPropagation(event)

    copy(value.email || value.fullname) // External contact has fullname as email
  }

  return (
    <ProfileUsersWidgetItem
      {...restProps}
      Icons={EmailProfileWidgetParticipantsItemIcons}
      iconsProps={{
        copied,
        onCopy: handleClickCopy,
      }}
      isArchived={value.archived}
      value={value}
    />
  )
}

export default EmailProfileWidgetParticipantsItem
